import React from 'react'

const CheckCircleIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83366 10.4993L6.02116 8.68685C5.86838 8.53407 5.68088 8.45768 5.45866 8.45768C5.23644 8.45768 5.04199 8.54102 4.87533 8.70768C4.72255 8.86046 4.64616 9.0549 4.64616 9.29102C4.64616 9.52713 4.72255 9.72157 4.87533 9.87435L7.25033 12.2493C7.4031 12.4021 7.59755 12.4785 7.83366 12.4785C8.06977 12.4785 8.26421 12.4021 8.41699 12.2493L13.1462 7.52018C13.2989 7.3674 13.3753 7.1799 13.3753 6.95768C13.3753 6.73546 13.292 6.54102 13.1253 6.37435C12.9725 6.22157 12.7781 6.14518 12.542 6.14518C12.3059 6.14518 12.1114 6.22157 11.9587 6.37435L7.83366 10.4993ZM9.00033 17.3327C7.84755 17.3327 6.76421 17.1138 5.75033 16.676C4.73644 16.2388 3.85449 15.6452 3.10449 14.8952C2.35449 14.1452 1.76088 13.2632 1.32366 12.2493C0.885881 11.2355 0.666992 10.1521 0.666992 8.99935C0.666992 7.84657 0.885881 6.76324 1.32366 5.74935C1.76088 4.73546 2.35449 3.85352 3.10449 3.10352C3.85449 2.35352 4.73644 1.75963 5.75033 1.32185C6.76421 0.884627 7.84755 0.666016 9.00033 0.666016C10.1531 0.666016 11.2364 0.884627 12.2503 1.32185C13.2642 1.75963 14.1462 2.35352 14.8962 3.10352C15.6462 3.85352 16.2398 4.73546 16.677 5.74935C17.1148 6.76324 17.3337 7.84657 17.3337 8.99935C17.3337 10.1521 17.1148 11.2355 16.677 12.2493C16.2398 13.2632 15.6462 14.1452 14.8962 14.8952C14.1462 15.6452 13.2642 16.2388 12.2503 16.676C11.2364 17.1138 10.1531 17.3327 9.00033 17.3327Z"
        fill="#5DB594"
      />
    </svg>
  )
}

export default CheckCircleIcon
